<agpr-take-over-panel
    [id]="id"
    class="agpr-addInteraction"
    header="Discover.interactionView.add"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [formGroup]="formGroup"
    (close)="closeDialog(null)"
    (visibleChange)="closeDialog(null)"
    [width]="30"
>
    <div class="content">
        <agpr-scroll-panel [agprLoading]="loading">
            <agpr-dropdown
                formControlName="type"
                [id]="id + '_interactionType'"
                class="agpr-addInteraction-type"
                label="Discover.interactionView.dialog.interactionType"
                placeholder="Discover.interactionView.dialog.interactionType.placeholder"
                [options]="typeOptions"
                [required]="true"
                [ariaDescribedBy]="id + '_interactionType_errorMessage'"
            ></agpr-dropdown>
            <agpr-form-message
                *ngIf="type.errors?.['required'] && (type.touched || submitTouched)"
                [id]="id + '_interactionType_errorMessage'"
                [marginBottom]="0"
            >
                {{ 'Discover.interactionView.dialog.noType' | localize }}
            </agpr-form-message>

            <label class="agpr-addInteraction-dateLabel">
                {{ 'Discover.interactionView.dialog.interactionDate' | localize }}
            </label>
            <span class="agpr-requiredAsterix"> * </span>
            <div class="agpr-addInteraction-date">
                <agpr-date-picker
                    formControlName="date"
                    #calendar
                    [id]="id + '_datePicker'"
                    (blur)="debouncedUpdateInteractionDate()"
                    (select)="debouncedUpdateInteractionDate()"
                ></agpr-date-picker>
                <agpr-form-message
                    *ngIf="date.errors?.['required']"
                    [id]="id + '_interactionDate_errorMessage'"
                    [marginBottom]="0"
                >
                    {{ 'Discover.interactionView.dialog.noDate' | localize }}
                </agpr-form-message>

                <agpr-time-picker
                    formControlName="time"
                    [id]="id + '_updateInteractionTime'"
                    infoIconStyleClass="agpr-addInteraction-timePickerIcon"
                    infoTooltipStyleClass="agpr-addInteraction-timPickerTooltip"
                    [showTimezoneDisclaimer]="false"
                    (changeTimeZone)="updateDate()"
                    (changeHour)="updateDate()"
                    (changeMinute)="updateDate()"
                    (changeMeridian)="updateDate()"
                ></agpr-time-picker>
                <agpr-form-message
                    *ngIf="time.errors?.['required']"
                    [id]="id + '_interactionTime_errorMessage'"
                    [marginBottom]="0"
                >
                    {{ 'Discover.interactionView.dialog.noTime' | localize }}
                </agpr-form-message>
            </div>

            <agpr-textarea-input
                formControlName="summary"
                [id]="id + '_summaryTextArea'"
                label="Discover.interactionView.dialog.interactionSummary"
                [maxLength]="2048"
                [bottomMargin]="false"
                [required]="true"
                [ariaDescribedBy]="id + '_summaryTextArea_errorMessage'"
            ></agpr-textarea-input>
            <agpr-form-message
                *ngIf="summary.errors?.['required'] && (summary.touched || submitTouched)"
                [id]="id + '_summaryTextArea_errorMessage'"
                [marginBottom]="0"
            >
                {{ 'Discover.interactionView.dialog.noSummary' | localize }}
            </agpr-form-message>

            <div class="agpr-addInteraction-notes">
                <agpr-textarea-input
                    formControlName="notes"
                    [id]="id + '_notesTextArea'"
                    class="agpr-addInteraction-notes"
                    label="Discover.interactionView.dialog.interactionNotes"
                    [maxLength]="2048"
                    [bottomMargin]="false"
                    [required]="false"
                    [ariaDescribedBy]="id + '_notesTextArea_errorMessage'"
                ></agpr-textarea-input>
            </div>

        </agpr-scroll-panel>

        <ng-template #takeOverFooterLeft>
            <agpr-button
                [id]="id + '_cancelButton'"
                label="cancel"
                [style]="buttonTypes.secondary"
                (click)="closeDialog(null)"
            ></agpr-button>
        </ng-template>

        <ng-template #takeOverFooterRight>
            <agpr-button
                [id]="id + '_okButton'"
                label="Discover.addPrivateDataDialog.ok"
                [style]="buttonTypes.primary"
                (click)="save()"
            ></agpr-button>
        </ng-template>
    </div>
</agpr-take-over-panel>
